module.exports = __webpack_public_path__ + "img/5-2.fca47348.png";